import React, { useContext } from 'react';
import { IoMdClose } from 'react-icons/io';

import { StartFarmContext } from '../../../context/startFarmContext';

const FarmContract = () => {
  const { handleContractModal, contractModal } = useContext(StartFarmContext);

  return (
    <div>
      <div className={contractModal ? 'show' : 'hidden'}>
        <div className="modal-bg">
          <div className="relative flex flex-wrap justify-center items-center h-screen w-screen">
            <div className="fixed top-0 left-0 bg-cf-300 text-gray-200 rounded p-3 ml-90 mt-16">
              Farm Contract
            </div>
            <div className="relative bg-white rounded p-16 w-120">
              <div
                onClick={handleContractModal}
                className="absolute right-0 top-0 mt-6 mr-6 text-2xl text-cf-dark font-bold cursor-pointer"
              >
                <IoMdClose />
              </div>
              <h4 className="text-center mb-4">Farm Contract</h4>
              <div className="text-sm">
                <p className="my-4">
                  Can you imagine what we will be downloading in another twenty years? I mean who
                  would have ever thought that you could record sound with digital quality fifty
                  years ago? Now we routinely download whole albums worth of music in a couple of
                  minutes to ipods that hold thousands of songs in the space the size of a zippo
                  lighter!
                </p>
                <p>
                  What I wonder is what will we download in the future? We can get degrees on line
                  now, which means that we are actually downloading our future doesn’t it. Sounds
                  kind of funny, but true to say that in the future we will be downloading our
                  future. Will we download our jobs? I mean more and more people are working at home
                  aren’t they? I could see the next wave of employment being over the internet where
                  you never actually see your boss or maybe you will see him in downloaded form.
                  That would be kind of weird wouldn’t it? It would be cool in the sense that you
                  could be dressed however you want and you could be
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmContract;
